import { brightspotConfig } from '../../config'

export default function getConfig() {
  return brightspotConfig.api
}
